/**
 * 관리자 회원가입 통계
 * ($j.Pages.Admin.MemberSignup / body data-page-name="MemberSignup")
 *
 * 월별 가입/탈퇴/유료 추이 + 가입 분해(회원구분·경로·지역·장비).
 */
export default class MemberSignup {
    constructor() {
        this.trendChart = null;
        this.bdChart = null;
        this.buckets = [];
        this.breakdownTrend = null;
        this.palette = ['#0d6efd', '#198754', '#fd7e14', '#6610f2', '#20a8a8', '#dc3545', '#6c757d', '#e83e8c'];
    }

    initialize() {
        $('#msRefresh').on('click', () => this._load(true));
        $('#msPeriod').on('change', () => this._load());
        $('#msBdDim').on('change', () => this._renderBreakdown());
        this._load();
    }

    async _load(nocache = false) {
        try {
            const [unit, periods] = String($('#msPeriod').val()).split(':');
            const data = { unit, periods };
            if (nocache) data.nocache = 1;
            const res = await $.ajax({ url: '/adm/ajax/stat/members/data', type: 'get', data });
            if (!res.ok) return;
            this._renderSummary(res.summary);
            this._renderTrend(res.trend);
            this.buckets = res.trend.map(t => t.bucket);
            this.breakdownTrend = res.breakdown_trend;
            this._renderBreakdown();
            if (res.cached_at) $('#msCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('회원가입 통계 로드 실패', e);
        }
    }

    _renderSummary(s) {
        $('#msSignup').text(this._c(s.total_signup));
        $('#msAvg').text(`${s.avg_label} ${s.avg_signup}명`);
        $('#msLeave').text(this._c(s.total_leave));
        $('#msNet').text((s.net >= 0 ? '+' : '') + this._c(s.net));
        $('#msPaid').text(this._c(s.paid_now));
        $('#msSocial').text(s.social_pct + '%');
        $('#msRec').text(s.recommended_pct + '%');
    }

    _renderTrend(trend) {
        const ctx = document.getElementById('msTrendChart').getContext('2d');
        if (this.trendChart) this.trendChart.destroy();

        const labels = trend.map(t => this._fmt(t.bucket));
        this.trendChart = new Chart(ctx, {
            data: {
                labels,
                datasets: [
                    { type: 'bar', label: '가입', data: trend.map(t => t.signup), backgroundColor: '#0d6efd', order: 2, yAxisID: 'y' },
                    { type: 'bar', label: '탈퇴', data: trend.map(t => t.leave), backgroundColor: '#dc3545', order: 2, yAxisID: 'y' },
                    { type: 'line', label: '유료회원', data: trend.map(t => t.paid), borderColor: '#198754', backgroundColor: '#198754', tension: .25, order: 1, yAxisID: 'y1' },
                ]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: {
                    y: { beginAtZero: true, position: 'left', title: { display: true, text: '가입/탈퇴' } },
                    y1: { beginAtZero: true, position: 'right', title: { display: true, text: '유료회원' }, grid: { drawOnChartArea: false } },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            afterBody: (items) => {
                                const t = trend[items[0].dataIndex];
                                return `순증 ${t.net >= 0 ? '+' : ''}${t.net}` + (t.is_partial ? ' (진행중)' : '');
                            }
                        }
                    }
                }
            }
        });
    }

    _renderBreakdown() {
        if (!this.breakdownTrend) return;
        const dim = $('#msBdDim').val();
        const rows = this.breakdownTrend[dim] || [];
        const labels = this.buckets;

        // 카테고리 추출 + 버킷별 피벗
        const cats = [...new Set(rows.map(r => r.cat))];
        const map = {};
        rows.forEach(r => { (map[r.cat] = map[r.cat] || {})[r.bucket] = r.count; });

        const datasets = cats.map((cat, idx) => ({
            label: cat,
            data: labels.map(b => (map[cat] && map[cat][b]) || 0),
            backgroundColor: this.palette[idx % this.palette.length],
            stack: 's',
        }));

        const ctx = document.getElementById('msBdChart').getContext('2d');
        if (this.bdChart) this.bdChart.destroy();
        this.bdChart = new Chart(ctx, {
            type: 'bar',
            data: { labels: labels.map(b => this._fmt(b)), datasets },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: { x: { stacked: true }, y: { stacked: true, beginAtZero: true } },
                plugins: { legend: { position: 'bottom' } }
            }
        });
    }

    _bars(sel, items, limit) {
        if (!items || !items.length) { $(sel).html('<span class="text-muted small">없음</span>'); return; }
        const list = limit ? items.slice(0, limit) : items;
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...list.map(i => i.count));
        const html = list.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            const color = this.palette[idx % this.palette.length];
            return `<div class="row-item">
                <span class="lbl">${i.label}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${color}"></span>
                <span class="val">${this._c(i.count)} (${pct}%)</span>
            </div>`;
        }).join('');
        $(sel).html(html);
    }

    _fmt(b) {
        const s = String(b);
        if (s.length === 6) return `${s.slice(2, 4)}.${s.slice(4)}`; // YYYYMM → YY.MM
        return s; // YYYY
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        if (this.trendChart) { this.trendChart.destroy(); this.trendChart = null; }
        if (this.bdChart) { this.bdChart.destroy(); this.bdChart = null; }
    }
}
